module.exports = __webpack_public_path__ + "img/3.e7652ee0.png";